<template>
  <div class="container_warp">
    <div id="containerChart"></div>
    <!-- 顶部工具栏-->
    <TopDrawer @deleteNode="deleteNode" @changeLineType="changeLineType" @changeLineTypeDouble="changeLineTypeDouble"
               @changeDynamicLine="changeDynamicLine" @changeEdgeType="changeEdgeType" :graph="graph" :spaceId="spaceId" :topologyId="topologyId"></TopDrawer>
    <!-- 右侧节点编辑栏-->
    <RightDrawer class="right_drawer" :drawer="rightDrawer" :drawerType="type" :selectCell="selectCell" :graph="graph"
                 :grid="grid" 
                 :spaceId="spaceId"
                 @changeRightDrawer="changeRightDrawer" @deleteNode="deleteNode" @updateEdgeColor="updateEdgeColor" @updateEdgeWidth="updateEdgeWidth"></RightDrawer>
    <!-- 左侧节点列表栏-->
    <LeftDrawer @changeLeftDrawer="changeLeftDrawer" :graph="graph" :drawer="leftDrawer"></LeftDrawer>
  </div>
</template>
<script>
import '@antv/x6-vue-shape'
import {isNullOrUnderfined} from "../../utils/tool";
import {Graph, Shape, FunctionExt} from '@antv/x6';
import TopDrawer from "./components/TopDrawer";
import RightDrawer from './components/RightDrawer';
import LeftDrawer from "./components/LeftDrawer";
import insertCss from 'insert-css';
import {query} from "@/network/device-topology"

export default {
  data() {
    return {
      // 拓扑图id
      topologyId:'',
      spaceId:'',
      graph: '',
      graphJson:{},
      value1: true,
      type: 'grid',
      selectCell: '',
      // 节点初始化设置
      edgeObject: {
        attrs: {
          line: {
            stroke: '#CCCCCC',
            strokeWidth: 4,
            targetMarker: {
              name: 'classic',
              size: 8
            },
            strokeDasharray: 0, //虚线
            style: {
              animation: 'none'
            },
          },
        },
        // 连接方式（默认单向箭头）
        connector: 'normal',
        router: {
          name: ''
        },
        label: {
          text: ''
        },
        zIndex: 2
      },
      grid: { // 网格设置
        size: 20,      // 网格大小 10px
        visible: true, // 渲染网格背景
        type: 'mesh',
        args: {
          color: '#0E2E48',
          thickness: 1,     // 网格线宽度/网格点大小
          factor: 10,
        }
      },
      // 右抽屉显示节点编辑器
      rightDrawer: true,
      // 左侧抽屉节点列表
      leftDrawer: true,
      // 关闭告警弹窗定时器
      closeTimer: null
    }
  },
  components: {
    RightDrawer, LeftDrawer, TopDrawer
  },
  methods: {
    queryTopology() {
      query(this.spaceId).then(res => {
        if (res.code === 0) {
          if (res.data) {
            this.topologyId = res.data.id
            this.graphJson = JSON.parse(res.data.dataJson)
            console.log(this.graphJson, 'this.graphJson')
            this.graph.fromJSON(this.graphJson)
            const container = document.getElementById('containerChart')
            const ports = container.querySelectorAll(
              '.x6-port-body'
            )
            this.showPorts(ports, false)
          } else {
            this.graphJson = {}
            this.graph.fromJSON(this.graphJson)
          }
        } else {
          this.graphJson = {}
          this.graph.fromJSON(this.graphJson)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    initX6() {
      var _that = this
      this.graph = new Graph({
        container: document.getElementById('containerChart'),
        width: '1920',
        height: '1080',
        grid: _that.grid,
        resizing: { //调整节点宽高
          enabled: true,
          orthogonal: false,
        },
        // 滚轮缩放
        mousewheel: {
          enabled: true,
          modifiers: ['ctrl'],
        },
        panning: true, // 开启平移
        selecting: true, //可选
        snapline: true,
        interacting: {
          edgeLabelMovable: true,
        },
        connecting: { // 节点连接
          anchor: 'center',
          connectionPoint: 'anchor',
          allowBlank: false,
          snap: true,
          createEdge() {
            return new Shape.Edge(_that.edgeObject)
          },
        },
        highlighting: {
          magnetAvailable: {
            name: 'stroke',
            args: {
              padding: 4,
              attrs: {
                strokeWidth: 4,
                stroke: '#6a6c8a'
              }
            }
          }
        },
        // 开启历史记录
        history: {
          enabled: true,
          beforeAddCommand(event, args) {
            if (args.options) {
              return args.options.ignore !== false
            }
          },
        }
      });
      // 内容与视图居中
      this.graph.centerContent()
      insertCss(`
              @keyframes ant-line {
                to {
                    stroke-dashoffset: -1000
                }
              }
            `)
      // 鼠标移入移出节点
      this.graph.on('node:mouseenter', FunctionExt.debounce(() => {
          const container = document.getElementById('containerChart')
          const ports = container.querySelectorAll(
            '.x6-port-body'
          )
          this.showPorts(ports, true)
        }),
        500
      )
      this.graph.on('node:mouseleave', () => {
        const container = document.getElementById('containerChart')
        const ports = container.querySelectorAll(
          '.x6-port-body'
        )
        this.showPorts(ports, false)
      })
      this.graph.on('blank:click', () => {
        this.type = 'grid'
      })
      this.graph.on('cell:click', ({cell}) => {
        if (cell.isNode()) {
          if (!isNullOrUnderfined(cell.store.data.attrs.image)) {
            this.type = 'image'
          } else {
            this.type = 'node'
          }
        } else {
          this.type = 'edge'
        }
      })
      this.graph.on('selection:changed', (args) => {
        console.log(args, 'args')
        args.added.forEach(cell => {
          this.selectCell = cell
          if (cell.isEdge()) {
            // 获取当前线条的 strokeDasharray 值
            // const currentDash = cell.attr('line/strokeDasharray')
            // // 如果当前是实线(0)则变为虚线(5)，反之变为实线(0)
            // const newDash = currentDash === 0 ? 5 : 0
            // cell.attr('line/strokeDasharray', newDash)
            
            cell.addTools([
              {
                name: 'vertices',
                args: {
                  padding: 4,
                  attrs: {
                    strokeWidth: 0.1,
                    stroke: '#2d8cf0',
                    fill: '#ffffff',
                  }
                },
              },
            ])
          }
        })
        args.removed.forEach(cell => {
          cell.removeTools()
        })
      })
    },
    showPorts(ports, show) {
      for (let i = 0, len = ports.length; i < len; i = i + 1) {
        ports[i].style.visibility = show ? 'visible' : 'hidden'
      }
    },
    // 删除节点
    deleteNode() {
      const cell = this.graph.getSelectedCells()
      this.graph.removeCells(cell)
      this.type = 'grid'
    },
    // 改变边形状
    changeEdgeType(e) {
      if (e === 'normal') {
        // 给初始化连接线赋值
        this.edgeObject.connector = 'normal'
        this.edgeObject.router = {name: ''}
      } else if (e === 'smooth') {
        this.edgeObject.connector = 'smooth'
        this.edgeObject.router = {name: ''}
      } else if (e === 'rightAngle') {
        this.edgeObject.connector = 'normal'
        this.edgeObject.router = {name: 'manhattan'}
      } else {
        // 默认单向箭头
        this.edgeObject.connector = 'normal'
        this.edgeObject.router = {name: ''}
      }
    },
    // 改变成双向箭头
    changeLineType(flag) {
      if (flag) {
        // 连接自己的一头
        this.edgeObject.attrs.line.sourceMarker = {name: 'circle', size: 8}
        // 连接目标的一头
        this.edgeObject.attrs.line.targetMarker = {name: 'circle', size: 8}
      } else {
        // 连接自己的一头
        this.edgeObject.attrs.line.sourceMarker = {}
        // 连接目标的一头
        this.edgeObject.attrs.line.targetMarker = {name: 'classic', size: 8}
      }
    },
    changeLineTypeDouble(flag) {
      if (flag) {
        // 连接自己的一头
        this.edgeObject.attrs.line.sourceMarker = {name: 'classic', size: 8}
        // 连接目标的一头
        this.edgeObject.attrs.line.targetMarker = {name: 'classic', size: 8}
      } else {
        // 连接自己的一头
        this.edgeObject.attrs.line.sourceMarker = {}
        // 连接目标的一头
        this.edgeObject.attrs.line.targetMarker = {name: 'classic', size: 8}
      }
    },
    // 改变左侧工具栏是否打开
    changeLeftDrawer() {
      this.leftDrawer = !this.leftDrawer
    },
    // 改变右侧工具栏是否打开
    changeRightDrawer() {
      this.rightDrawer = !this.rightDrawer
    },
    // 处理动态虚线切换
    changeDynamicLine(flag) {
      if (flag) {
        this.edgeObject.attrs.line.strokeDasharray = 5
        this.edgeObject.attrs.line.style = {
          animation: 'ant-line 30s infinite linear'
        }
      } else {
        this.edgeObject.attrs.line.strokeDasharray = 0
        this.edgeObject.attrs.line.style = {
          animation: 'none'
        }
      }
    },
    // 更新默认线条颜色
    updateEdgeColor(color) {
      this.edgeObject.attrs.line.stroke = color
    },
    // 更新默认线条宽度
    updateEdgeWidth(width) {
      this.edgeObject.attrs.line.strokeWidth = width
    }
  },
  mounted() {
    if(!this.$route.query.spaceId){
      this.$message.info('没有找到空间信息，请检查是否网络有问题！')
    }
    this.spaceId=this.$route.query.spaceId
    this.queryTopology()
    // 关闭告警弹窗定时器
    this.closeTimer = setInterval(() => {
      if (document.getElementsByClassName('el-notification right')) {
        document.getElementsByClassName('el-notification right')[0].style.display = 'none'
      }
    }, 6000)
    this.initX6()
  },
  destroyed() {
    clearInterval(this.closeTimer)
    this.closeTimer = null
    this.graph.dispose()
  }
}
</script>

